import axiosHttpRequest from "../axios";

async function dmsFileUploadService(
  endpoint,
  queryparams,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execMultiPartRequestWithParams(
    endpoint,
    queryparams,
    postdata,
    configheaders
  );
  return serviceResponse;
}

async function dmsFileDeleteService(endpoint, queryparams, configheaders) {
  const serviceResponse = await axiosHttpRequest.execDeleteRequestsWithParams(
    endpoint,
    queryparams,
    configheaders
  );
  return serviceResponse;
}

async function bpcFileUploadService(
  endpoint,
  queryparams,
  postdata,
  configheaders
) {
  const serviceResponse = await axiosHttpRequest.execMultiPartRequestWithParams(
    endpoint,
    queryparams,
    postdata,
    configheaders
  );
  return serviceResponse;
}

export default {
  dmsFileUploadService,
  dmsFileDeleteService,
  bpcFileUploadService,
};
